export default __webpack_public_path__ + "static/media/Balgruf.0ff87c78.otf";